import { JSONEditor } from '@json-editor/json-editor'
// import _ from 'lodash'
// import { extend } from '../utilities.js'

class TypeSelector extends JSONEditor.AbstractEditor {
  constructor (options, defaults) {
    super(options, defaults)
    this.previousChildEditorType = null
    this.currentChildEditorType = null
    this.cachedValues = {}
    this.isBasic = options.jsoneditor.options.isBasic || false
  }

  register () {
    if (this.typeEditor) this.typeEditor.unregister()
    if (this.childEditor) this.childEditor.unregister()

    if (this.typeEditor) this.typeEditor.register()
    if (this.childEditor) this.childEditor.register()
    super.register()
  }

  unregister () {
    super.unregister()
    if (this.typeEditor) {
      this.typeEditor.unregister()
    }
    if (this.childEditor) {
      this.childEditor.unregister()
    }
  }

  preBuild () {
    super.preBuild()

    this.typePropertyName = this.options.typeProperty || 'type'
    if (!this.schema.properties[this.typePropertyName]) {
      throw new Error(`TypeSelector::Missing ${this.typePropertyName} property in schema`)
    }

    const editorClass = this.jsoneditor.getEditorClass(this.schema.properties[this.typePropertyName])
    const typeEditorSchema = this.schema.properties[this.typePropertyName]
    this.typeEditor = this.jsoneditor.createEditor(editorClass, {
      jsoneditor: this.jsoneditor,
      schema: typeEditorSchema,
      path: `${this.path}.${this.typePropertyName}`,
      parent: this
    })
    this.typeEditor.options.stayVisible = true
    this.typeEditor.preBuild()
  }

  build () {
    this.header = document.createElement('span')
    this.header.textContent = this.getTitle()
    this.title = this.theme.getHeader(this.header)
    this.title.classList.add('je-object__title')
    this.container.appendChild(this.title)
    this.container.classList.add('je-object__container')

    this.editor_holder = this.theme.getIndentedPanel()
    this.container.appendChild(this.editor_holder)

    this.row_container = this.theme.getGridContainer()
    this.editor_holder.appendChild(this.row_container)

    const typeEditorHolder = this.theme.getGridColumn()
    this.row_container.appendChild(typeEditorHolder)

    this.jsoneditor.watch(this.typeEditor.path, () => {
      if (this.typeEditor.getValue() !== this.currentChildEditorType) {
        this.previousChildEditorType = this.currentChildEditorType
        this.currentChildEditorType = this.typeEditor.getValue()
        this.switchEditor()
      }
    })
    this.typeEditor.setContainer(typeEditorHolder)
    this.typeEditor.build()
    // console.log('type after build : ', this.typeEditor.getValue()) // value is set at this point
    this.typeEditor.postBuild()
    if (this.isBasic) {
      this.typeEditor.disable() // disable the type selector if in basic mode
    }
    // if the type property is hidden, hide the selector dropdown
    if (this.schema.properties[this.typePropertyName]?.options?.hidden) {
      typeEditorHolder.style.display = 'none'
    }
  }

  setValue (value, initial) {
    // console.log('typeselector set value', value, initial)
    value = value || {}

    // const prevType = this.typeEditor.getValue()
    const typeEditorVal = value[this.typePropertyName] ?? this.typeEditor.getDefault()
    this.typeEditor.setValue(typeEditorVal, initial)

    if (this.childEditor) {
      this.childEditor.setValue(value[typeEditorVal], initial)
    }
  }

  onChildEditorChange (editor) {
    this.refreshValue()
    // see note above about why we're removing
    // this.refreshValueDebounced()
    super.onChildEditorChange(editor)
  }

  switchEditor () {
    // console.log('switch editor')
    if (this.childEditor) {
      this.cacheValue(this.previousChildEditorType)

      // console.log('switchEditor::destroying childEditor')
      this.childEditor.destroy()
      this.childEditor = null
    }

    const type = this.typeEditor.getValue()
    this.buildChildEditor(type)

    this.register()

    // if switching back to a previous editor type, restore the cached value
    const childEditorValue = this.cachedValues[type] || this.childEditor.getDefault()
    this.childEditor.setValue(childEditorValue)

    this.refreshValue()
  }

  buildChildEditor (type) {
    const editorClass = this.jsoneditor.getEditorClass(this.schema.properties[type])
    const childSchema = this.schema.properties[type]
    this.childEditor = this.jsoneditor.createEditor(editorClass, {
      jsoneditor: this.jsoneditor,
      schema: childSchema,
      path: `${this.path}.${type}`,
      parent: this
    })
    this.childEditor.preBuild()

    const childEditorHolder = this.theme.getGridColumn()
    this.row_container.appendChild(childEditorHolder)
    this.childEditor.setContainer(childEditorHolder)

    this.childEditor.build()
    this.childEditor.postBuild()
  }

  cacheValue (key) {
    if (!key) return

    if (this.childEditor && this.childEditor.getValue()) {
      this.cachedValues[key] = this.childEditor.getValue()
    }
  }

  getValue () {
    return this.value
  }

  refreshValue () {
    // console.log('-- refresh value', this.value)
    this.value = {}

    if (!this.typeEditor) {
      return
    }

    this.value[this.typePropertyName] = this.typeEditor.getValue()
    this.value[this.typeEditor.getValue()] = this.childEditor.getValue()
  }
}

export default TypeSelector
